import { TMessageSchema, TMessagesResponseError, TMessagesMap } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { ERequestTrigger } from '../../types/requestTrigger';

export interface IMessagesState {
  unreadCount: number;
}

export type TSetAsReadPayload = {
  chatId: string;
  messageIds: string[];
  messagesMap: TMessagesMap;
};

export type TMessageListPayload = {
  messages: TMessageSchema[];
  chatId?: string;
  messagesMap: TMessagesMap;
};
export type TMessagesV2ListPayload = {
  messages: TMessageSchema[];
  chatId?: string;
  messagesMap: TMessagesMap;
};

export type TMessagesErrorPayload = {
  chatId: string;
  error: TMessagesResponseError;
};

export interface ISynchronizationMessagesParams {
  chatId: string;
  /**
   * Фоновая проверка обновлений: чат только помечается как загружающийся,
   * без переключения текущего открытого чата и мобильной панели
   */
  isOnlyCheckUpdate?: boolean;
  /** Смещение в списке сообщений чата, с которого берутся rowVersion для запроса */
  offset?: number;
  /** Дата создания самого раннего уже синхронизированного сообщения, граница для следующей страницы */
  createdAt?: string;
  /** Источник запроса, пишется в логи */
  trigger?: ERequestTrigger;
}

export interface IUpdateMessagesParams {
  chatId: string;
  /** Фоновая проверка обновлений без переключения текущего открытого чата */
  isOnlyCheckUpdate?: boolean;
  /** Источник запроса, пишется в логи */
  trigger?: ERequestTrigger;
}

export enum EMessagesActionTypes {
  SetAsRead = 'messages/set-as-read',
  SetMessagesPending = 'messages/pending',
  SetMessagesFulfilled = 'messages/fulfilled',
  SetMessagesFailed = 'messages/failed',
  SetSynchronizationMessagesFulfilled = 'messages/synchronization/fulfilled',
  SetSynchronizationMessagesPending = 'messages/synchronization/pending',
}

export type TMessagesActions =
  | ITypedReduxAction<EMessagesActionTypes.SetAsRead, TSetAsReadPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesPending, { chatId: string }>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFulfilled, TMessageListPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFailed, TMessagesErrorPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetSynchronizationMessagesPending, { chatId: string }>
  | ITypedReduxAction<EMessagesActionTypes.SetSynchronizationMessagesFulfilled, TMessagesV2ListPayload>;
